import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose REP: see the repair and execute its next step (start, resolve with materials used, escalate)
 * @purpose WAR: decide on the warranty case (start or reject)
 * @purpose MAT: approve or ship the order and record shipments
 * @primary Current state + available transition actions
 * @persona mecanico-externo, sports-manager-ikos, paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/requests/$id")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
